import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";
import { isValidLocale, switchLanguage, RTL_LOCALES, DEFAULT_LOCALE } from "../../lib/i18n";
import { CookieConsentBanner } from "../../shared/layout/cookie-consent-banner";

/**
 * The partner-only area (`/{lang}/partner/*`): trip organisers, not guests.
 *
 * A sibling of the guest `_layout`, so none of the guest chrome comes with
 * it: no site header, bottom bar, footer, MaJourneys AI pill, app promo or
 * language suggestion. The partner shell draws its own slim bar and tabs.
 * The cookie banner stays: consent is a legal requirement on every page.
 *
 * The locale handling is the guest layout's, unchanged: same redirect for a
 * bad locale, same client-only language switch (see `_layout.tsx` for why).
 */
export const Route = createFileRoute("/$lang/_partner")({
  beforeLoad: async ({ params, location }) => {
    if (!isValidLocale(params.lang)) {
      throw redirect({ href: `/${DEFAULT_LOCALE}${location.href}`, statusCode: 301 });
    }
    if (typeof window !== "undefined") {
      await switchLanguage(params.lang);
    }
  },
  component: PartnerLayout,
});

function PartnerLayout() {
  const { lang } = Route.useParams();
  const isRtl = RTL_LOCALES.includes(lang as (typeof RTL_LOCALES)[number]);
  return (
    <div
      dir={isRtl ? "rtl" : "ltr"}
      className="flex min-h-screen flex-col bg-bg-body font-sans"
      style={{ fontFamily: isRtl ? "var(--font-rtl)" : undefined }}
    >
      <Outlet />
      <CookieConsentBanner />
    </div>
  );
}
